import React, { useState, useEffect, useCallback } from 'react'
import { Route, Redirect, Switch, withRouter } from "react-router-dom";
import Menu from '../Components/Menu';
import { getUserRoutes as routes } from './Routes'
import { connect } from 'react-redux'
import CompanyForm from '../Pages/Company/CompanyForm'
import to from 'await-to-js'
import { toaster } from 'evergreen-ui'
import axios from '../Utils/axios'
import { handleLogout } from '../Redux/reducers/auth';
const ProtectedRoutes = ({
  isLogged, hasCompany, user, auth, dispatch, requestPasswordChange, history, ...props
}) => {
  const [visible, setVisibility] = useState(true)

  const validateToken = useCallback(async () => {
    const [err] = await to(axios.get('/accounts/user'))
    if (err && err.response && (err.response.status === 401 || err.response.status === 400)) {
      toaster.closeAll()
      toaster.danger('Sua sessão expirou, faça login para continuar')
      dispatch(handleLogout())
    }
  }, [dispatch])

  useEffect(() => {
    if (isLogged)
      validateToken()

    if (isLogged && hasCompany && user.account && user.account.user && !user.account.user.requestPasswordChange) setVisibility(true)
  }, [user, hasCompany, isLogged, validateToken])

  useEffect(() => {
    if (isLogged && hasCompany && user.account && user.account.user && user.account.user.requestPasswordChange) {
      setVisibility(false)
      history.push('/accounts/password')
    }
  }, [isLogged, hasCompany, history, user])

  if (!isLogged) return <Redirect to='/login' />

  return (
    isLogged && (hasCompany) ?
      <React.Fragment >
        {visible && (
          <Menu visible={visible}
            changeVisibility={(isVisible) => setVisibility(isVisible)}
            {...props}
          />
        )}

        <div style={{ marginLeft: !visible ? 70 : 250, marginTop: 10, marginRight: 20 }}>
          <Switch>
            <Route exact path='/' render={() => (
              <Redirect to='/home' />
            )} />
            {routes(user.account.role).map(route => (
              <PrivateRoute key={route.path} exact path={route.path} component={route.component} />
            ))}
            <Route render={() => (
              <h1> Página não encontrada </h1>
            )} />
          </Switch>
        </div>
      </React.Fragment >
      : (
        <CompanyForm />
      )
  )
}
const PrivateRoute = ({ component: Component, ...rest }) => (

  <Route {...rest} render={(props) => (
    <Component {...props} />
  )} />

)

export const mapStateToProps = ({ auth }) => {
  return {
    isLogged: !!auth.isLogged,
    hasCompany: !!auth.account && !!auth.account.company,
    user: auth,
  }
}

export default withRouter(connect(mapStateToProps)(ProtectedRoutes))